import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";

export default function Membership() {
  const [products, setProducts] = useState(null);
  useEffect(() => { client.get("/billing/products").then((r) => setProducts(r.data)); }, []);
  const alpha = (products || []).filter((p) => p.type !== "analyst");
  const analysts = (products || []).filter((p) => p.type === "analyst");

  const Card = ({ p }) => (
    <div data-testid={`plan-${p.id}`} className="rounded-2xl border border-white/10 bg-[#0b0b0b] p-6 flex flex-col">
      <p className="text-[10px] font-mono-cl uppercase tracking-[0.18em] text-zinc-500">{p.type === "analyst" ? "Analyst" : "Membership"}</p>
      <h3 className="font-display text-2xl font-bold mt-1">{p.name}</h3>
      {p.analyst && <p className="text-sm text-zinc-400">{p.analyst.name}</p>}
      <p className="mt-4"><span className="font-display text-4xl font-black">${p.price_usd}</span><span className="text-zinc-500 text-sm"> / {p.period_days} days · USDT</span></p>
      <p className="text-sm text-zinc-400 mt-3 flex-1">{p.description}</p>
      {p.benefits?.length > 0 && <ul className="mt-4 space-y-1 text-sm text-zinc-300">{p.benefits.map((b) => <li key={b}>· {b}</li>)}</ul>}
      <Link to={`/checkout/${p.id}`} data-testid={`plan-buy-${p.id}`} className="mt-6 text-center py-3 rounded-full bg-[#ccff00] text-black text-sm font-semibold hover:brightness-110 transition-[filter]">Subscribe with USDT</Link>
    </div>
  );

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14" data-testid="membership-page">
      <p className="font-mono-cl text-[11px] tracking-[0.24em] uppercase text-[#ccff00]">Membership</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Plans</h1>
      <p className="text-zinc-400 mt-3 max-w-xl">Pay with USDT for a fixed access period. Analyst subscriptions are independent: each one unlocks only that analyst's research.</p>
      {products?.length === 0 && <p data-testid="membership-empty" className="mt-10 text-zinc-500">No plans are open right now. Check back soon.</p>}
      {alpha.length > 0 && <div className="grid md:grid-cols-3 gap-5 mt-10">{alpha.map((p) => <Card key={p.id} p={p} />)}</div>}
      {analysts.length > 0 && (
        <>
          <h2 className="font-display text-lg font-bold mt-14 mb-4">Individual analysts</h2>
          <div className="grid md:grid-cols-3 gap-5">{analysts.map((p) => <Card key={p.id} p={p} />)}</div>
        </>
      )}
    </div>
  );
}
